// src/pages/PoaPage.js
import React, { useEffect, useState } from 'react';
import {
  Container, Table, TableHead, TableRow, TableCell, TableBody,
  Button, Paper, Typography, Box, CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../api/axiosConfig';

const PoaPage = () => {
  const [poas, setPoas] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    const fetchPoas = async () => {
      try {
        const res = await api.get('/poa/');
        setPoas(res.data);
      } catch (err) {
        console.error('Error al cargar POAs:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchPoas();
  }, []);

  if (loading) return <CircularProgress sx={{ mt: 4, display: 'block', mx: 'auto' }} />;

  return (
    <Container>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5">Planes Operativos Anuales (POA)</Typography>
        <Button variant="contained" onClick={() => navigate('/poa/nuevo')}>
          Nuevo POA
        </Button>
      </Box>
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Año</TableCell>
              <TableCell>Departamento</TableCell>
              <TableCell>Activo</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {poas.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">No hay POAs registrados</TableCell>
              </TableRow>
            ) : (
              poas.map((poa) => (
                <TableRow
                  key={poa.id_poa_proyecto}
                  hover
                  style={{ cursor: 'pointer' }}
                >
                  <TableCell onClick={() => navigate(`/poa/${poa.id_poa_proyecto}`)}>
                    {poa.id_poa_proyecto}
                  </TableCell>
                  <TableCell onClick={() => navigate(`/poa/${poa.id_poa_proyecto}`)}>
                    {poa.descripcion}
                  </TableCell>
                  <TableCell onClick={() => navigate(`/poa/${poa.id_poa_proyecto}`)}>
                    {poa.anno}
                  </TableCell>
                  <TableCell onClick={() => navigate(`/poa/${poa.id_poa_proyecto}`)}>
                    {poa.id_departamento}
                  </TableCell>
                  <TableCell onClick={() => navigate(`/poa/${poa.id_poa_proyecto}`)}>
                    {poa.activo ? 'Sí' : 'No'}
                  </TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{ mr: 1 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/poa/${poa.id_poa_proyecto}/metas`);
                      }}
                    >
                      Metas
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      sx={{ mr: 1 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/poa/${poa.id_poa_proyecto}/matriz`);
                      }}
                    >
                      Matriz
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={(e) => {
                        e.stopPropagation();
                        window.open(`${API_BASE_URL}/api/reportes/matriz/${poa.id_poa_proyecto}/`, '_blank');
                      }}
                    >
                      PDF
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
};

export default PoaPage;